import { lazy } from "react";

const LinkPay = lazy(() => import("../pages/linkPay/LinkPay"));
const LinkPaySuccess = lazy(() => import("../pages/linkPay/LinkPaySuccess"));
const LinkPayFail = lazy(() => import("../pages/linkPay/LinkPayFail"));
const LinkPayPayInfo = lazy(() => import("../pages/linkPay/LinkPayPayInfo"));

export const linkPayRoutes = [
  { path: "/linkPay/:uuid", element: <LinkPay /> },
  { path: "/linkPay/:uuid/info", element: <LinkPayPayInfo /> },
  { path: "/linkPay/payment/success", element: <LinkPaySuccess /> },
  { path: "/linkPay/payment/fail", element: <LinkPayFail /> },
];